import Api from '@/services/Api'

export default {
    getAllRoles(){
        return Api().get('roles')
    },
    getAllRolesById(id){
        return Api().get('roles/rol/'+id)
    },
    updateRolById(id,nombre,descripcion){
        return Api().put('roles/update/'+ id+ '/' +nombre+'/'+descripcion)
    },
    createRol(form){
        return Api().post('roles', form)
    },
    inactivarRol(id){
        return Api(id).post('roles/inactivar/'+id)
    }
}